import { Record } from 'immutable';
class AccountManager extends Record({
  id: 0,
  email: '',
  name: '',
  type: '',
  ownerType: undefined
}, 'AccountManager') {}
AccountManager.fromJS = obj => new AccountManager(Object.assign({}, obj));
export default AccountManager;